
import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { buildSearchApiUrl } from './searchApi';

const FetchData = () => {
    // initialize the state variable with an empty array
    const [data, setData] = useState([]);

    // define the function that fetches the data
    const fetchData = async () => {
        const query = inputRef.current?.value?.trim() || '';
        if (!query) {
            setData([]);
            return;
        }

        const response = await fetch(buildSearchApiUrl(query));
        const json = await response.json();
        setData(json.items?.length > 0 ? json.items : []);
    };

    const inputRef = useRef(null);

    const handleSubmit = (event) => {
        event.preventDefault();

    };

    // return the JSX element
    return (
        <>
            <form onSubmit={handleSubmit}>
                <input type="text" name="s" id="search" placeholder="Search" ref={inputRef} />
                <button type="submit" onClick={fetchData}>
                    <i className="fa fa-search" />
                </button>
            </form>
            
            {data.length > 0 ? (
            <>
            {data.map((item, ind) => (
                <div id="cssmenu3" className="menu-one-page-menu-container mt-1">
                    <ul className="menu">
                        <li className="menu-item menu-item-type-custom menu-item-object-custom">
                            {/* <Link target="_blank" to={item['link']}><strong>{item['htmlTitle']}</strong></Link> */}
                            <u><Link target="_blank" to={item['link']} dangerouslySetInnerHTML={ {__html: item['htmlTitle'] }}></Link></u>
                            <div dangerouslySetInnerHTML={ {__html: item['htmlSnippet'] }} ></div>
                        </li>
                    </ul>
                </div>
            ))}
            </>
            ) : (
            <p className="mt-4  text-white">No data to display</p>
            )}


            
        </>
    );
};

export default FetchData;